import { Modal, Dialog } from '@material-ui/core';
import theme from './theme';

Modal.defaultProps = {
  disableScrollLock: false,
};

Dialog.defaultProps = {
  disableScrollLock: false,
};

export { theme };
